import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const CrewSupervisorStyled = styled(Box).attrs({ p: { sm: '500' } })`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[100]};
    border-bottom: solid 1px ${theme.colors.grey[300]};
    border-top: solid 1px ${theme.colors.grey[300]};
  `}
`;
